var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Input, Inject } from '@angular/core';
import { ViewBackgroundFillType } from '../../../../view-data/view/background/view-background-fill-type';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import { DEFAULT_GRAPH_SETTINGS } from '../../../core/settings/graph/default-graph-settings';
import { DefaultGraphCategories } from '../../../core/settings/graph/default-graph-categories';
var ViewBackgroundSettingsComponent = /** @class */ (function (_super) {
    __extends(ViewBackgroundSettingsComponent, _super);
    function ViewBackgroundSettingsComponent(injector, defaultGraphSettings) {
        var _this = _super.call(this, injector) || this;
        _this.FillType = ViewBackgroundFillType;
        var settings = defaultGraphSettings.settings.get(DefaultGraphCategories.Background);
        _this.defaultGraphId = settings ? settings.graphId : -1;
        return _this;
    }
    Object.defineProperty(ViewBackgroundSettingsComponent.prototype, "fillType", {
        get: function () {
            return this._fillType;
        },
        set: function (v) {
            var data = this.data;
            switch (v) {
                case ViewBackgroundFillType.SolidColor:
                    if (!this._solidColor || this._solidColor === 'white') {
                        this._solidColor = '#ffffff';
                    }
                    data.solidColor = this._solidColor;
                    delete data.imageId;
                    delete data.graphSetting;
                    break;
                case ViewBackgroundFillType.Image:
                    data.imageId = this.imageId;
                    delete data.solidColor;
                    delete data.graphSetting;
                    break;
                case ViewBackgroundFillType.Graph:
                    if (!this._graphSetting) {
                        this._graphSetting = { id: this.defaultGraphId };
                    }
                    data.graphSetting = this._graphSetting;
                    delete data.imageId;
                    delete data.solidColor;
                    break;
            }
            this.data.fillType = v;
            this._fillType = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewBackgroundSettingsComponent.prototype, "solidColor", {
        get: function () {
            return this._solidColor;
        },
        set: function (v) {
            this.data.solidColor = v;
            this._solidColor = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewBackgroundSettingsComponent.prototype, "imageId", {
        get: function () {
            return this._imageId;
        },
        set: function (v) {
            this.data.imageId = v;
            this._imageId = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewBackgroundSettingsComponent.prototype, "graphSetting", {
        get: function () {
            return this._graphSetting;
        },
        enumerable: true,
        configurable: true
    });
    ViewBackgroundSettingsComponent.prototype.ngOnInit = function () {
        var data = this.data;
        this._fillType = data.fillType;
        if (data.solidColor === 'white') {
            this._solidColor = '#ffffff';
        }
        else {
            this._solidColor = data.solidColor;
        }
        this._imageId = data.imageId;
        this._graphSetting = data.graphSetting;
    };
    ViewBackgroundSettingsComponent.prototype.setSolidColor = function (color) {
        this.solidColor = color;
    };
    __decorate([
        Input()
    ], ViewBackgroundSettingsComponent.prototype, "data", void 0);
    __decorate([
        Input()
    ], ViewBackgroundSettingsComponent.prototype, "configureId", void 0);
    ViewBackgroundSettingsComponent = __decorate([
        Component({
            selector: 'view-background-settings',
            styles: [".design-view-background-settings{ .color-picker{ width: 100px; height: 30px; } }"],
            template: "<div class=\"design-view-background-settings\"> <div class=\"fe-radio-select-header\"> <label for=\"FillType_SolidColor\"> <input id=\"FillType_SolidColor\" name=\"FillType\" [(ngModel)]=\"fillType\" [value]=\"FillType.SolidColor\" type=\"radio\">{{lc(\"ViewFillType_SolidColor\")}} </label> <label for=\"FillType_Image\"> <input id=\"FillType_Image\" name=\"FillType\" [(ngModel)]=\"fillType\" [value]=\"FillType.Image\" type=\"radio\">{{lc(\"ViewFillType_Image\")}} </label> <label for=\"FillType_Graph\"> <input id=\"FillType_Graph\" name=\"FillType\" [(ngModel)]=\"fillType\" [value]=\"FillType.Graph\" type=\"radio\">{{lc(\"ViewFillType_Graph\")}} </label> </div> <div [ngSwitch]=\"fillType\"> <div *ngSwitchCase=\"FillType.SolidColor\"> <div class=\"fe-modal-content\"> <label>{{lc(\"Fill_Color_Label\")}}</label> <div class=\"color-picker design-color-picker\"> <color-picker [color]=\"solidColor\" (sentColor)=\"setSolidColor($event)\"></color-picker> </div> </div> </div> <div *ngSwitchCase=\"FillType.Image\"> <fc-image-uploader [(imageId)]=\"imageId\"></fc-image-uploader> </div> <div *ngSwitchCase=\"FillType.Graph\"> <graph-setting [hiddenUseGraph]=\"true\" [configureId]=\"configureId\" [loadOnInit]=\"true\" [useGraph]=\"true\" [graphSetting]=\"graphSetting\"></graph-setting> </div> </div> </div>"
        }),
        __param(1, Inject(DEFAULT_GRAPH_SETTINGS))
    ], ViewBackgroundSettingsComponent);
    return ViewBackgroundSettingsComponent;
}(ConfigureComponentBase));
export { ViewBackgroundSettingsComponent };
